import React, { Component } from "react";
import { TextInput, Button, MaterialIcon } from '../atoms';
import { Container } from "./Container";

import { LoginController } from "../controllers";

export default class Login extends Container {

	constructor(props) {
		super(props);

		this.state = {
			EMAIL: "",
			PASSWORD: "",
			error: {}
		};

		this.controller = new LoginController(this);
	}

	componentDidMount() {
		this.controller.showIeMessage();
	}

	openModalIe() {
		$(document).ready(function () {
			$('#ie').modal();
		});
		return (
			<div id="ie" className="modal about-us">
				<div className="modal-content">
					<h4>Atenção</h4>
					<p className="about-text contant-from-modal-done-form">
						Você está utilizando o navegador Internet Explorer, pensando em experiência em nosso site,
						pedimos que utilize o navegador Google Chrome ou Mozila Firefox.
					</p>
					<p className="about-text contant-from-modal-done-form">
						<a href="https://www.google.com.br/chrome/browser/desktop/index.html">
							Clique aqui para pagina de download do navegador Google Chrome
						</a>
					</p>
				</div>
			</div>
		);
	}

	render() {
		const { EMAIL, PASSWORD, error } = this.state;
		const { changeAction } = this.controller;
		return(
			<section className="login flex -h">
				<div className="informations flex -v -sa">
					<div>
						<h2>Bem Vindo!</h2>
						<p>A melhor avaliação Hídrica do Brasil</p>
					</div>
					<div className="descriptions">
						<div>- Mensuração</div>
						<div>- Gestão</div>
						<div>- Engajamento e Comunicação</div>
					</div>
					<span className="mail"><MaterialIcon type="email" color="white"/>contato@h2ocompany.com.br</span>
				</div>
				<form action={this.controller.submitAction} className="box">
					<img src="/assets/images/logo.png"></img>
					<label className="label-login">Entrar</label>
					<TextInput
						id="EMAIL"
						value={EMAIL}
						type={"email"}
						changeAction={changeAction}
						label="E-mail"
						error={error["email"]}
					/>
					<TextInput
						type="password"
						id="PASSWORD"
						value={PASSWORD}
						changeAction={changeAction}
						label="Senha"
						error={error["password"]}
					/>
					<span onClick={this.controller.forgotPassword} className="forgot-password">Esqueci <b>minha senha</b></span>
					<Button className="bcg-green" clickAction={this.controller.submitAction}>Acesso</Button>
					<a href="/cadastrar" className="registration-link">Ainda não possui cadastro?<br/>Cliquei aqui e faça agora!</a>
				</form>
				<a style={{ position: "absolute", left: "99999999999999" }} className="waves-effect waves-light btn modal-trigger" href="#ie"></a>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// src/containers/Login.js